module.exports = __webpack_public_path__ + "static/ucc_logo-2c6aeea4f42867eb239bb07a976b07fb.png";